import Template from '../../components/template';
import AuthWall from '../../components/auth-wall';
import InsightContainer from '../../insight-container';
import {deserialize} from 'quantum-graph';

const queries = [
    deserialize({
        'version': 2,
        'baseQueryGraph': {
            'baseQuery': {
                'queryType': 'dim',
                'tableNodes': [
                    {
                        'id': 'patient-flow-provider-condition-sankey',
                        'dataset': 'patient-flow-provider-condition-sankey',
                        'columns': [
                            'begin_year_key',
                            'end_year_key',
                            'lob',
                            'origin_provider_type',
                            'origin_provider_number',
                            'origin_facility_dim_key',
                            'origin_condition_category',
                            'origin_condition_category_code',
                            'dest_provider_type',
                            'dest_provider_number',
                            'dest_facility_dim_key',
                            'dest_condition_category',
                            'dest_condition_category_code',
                            'patients',
                            'episodes',
                            'origin_allowed',
                            'dest_allowed'
                        ]
                    }
                ],
                'scaffoldType': ''
            },
            'joins': []
        },
        'sort': [
        ],
        'filters': [
        ],
        'transforms': []
    }
    
    
    
    )
];

export default function TestPage() {

    return <Template>
        <AuthWall>
            <div className='m-auto container grid grid-cols-4 gap-5 grid-rows-1 grid-flow-row h-48 my-5'>
                <InsightContainer type='sankey' dataConfig={{queries: queries, options: {}}} />
            </div>
        </AuthWall>
    </Template>;
}
